export default "/images/vendor/flag-icon-css/flags/1x1/kg.svg?4ad89b3a703d225e1f6d2e2128d573ea";